import React, { useMemo } from "react";
import { View } from "react-native";
import { useI18n } from "@lookiero/i18n-react";
import { Text } from "@lookiero/sty-psp-ui";
import { ReturnQuestionType } from "../../../../../../../projection/returnQuestion/returnQuestion.constants";
import { DOMAIN, I18nMessages } from "../../../../../i18n/i18n";
import { ReturnQuestionItem } from "../ReturnQuestionItem";
import { style as hostDefaultReturnQuestionItemStyle } from "./HostDefaultReturnQuestionItem.style";

const HostDefaultReturnQuestionItem: ReturnQuestionItem<ReturnQuestionType.HOST_DEFAULT> = ({
  returnQuestion,
  children,
}) => {
  const { formatMessage } = useI18n({ domain: DOMAIN });
  const isAllOptions = returnQuestion.translationKey === I18nMessages.RETURN_QUESTION_MAIN_ALL_OPINION;

  const style = useMemo(() => hostDefaultReturnQuestionItemStyle(), []);

  return (
    <>
      {returnQuestion.translationKey && returnQuestion.translationKey !== " " && !isAllOptions ? (
        <View style={style.title}>
          <Text level={3} variant="action">
            {formatMessage({ id: returnQuestion.translationKey })}
          </Text>
        </View>
      ) : null}
      {children}
    </>
  );
};

export { HostDefaultReturnQuestionItem };
